/* fable v2 16/10/26. Pacisia theme script. Progressive enhancement: every page works without it. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var supportsDialog = typeof HTMLDialogElement === 'function' && !!HTMLDialogElement.prototype.showModal;

  /* ---------- Dialog helpers (menu, search, filters, cart drawer, lightbox) ---------- */
  function openDialog(dlg, opener) {
    if (!dlg || !supportsDialog) return false;
    dlg._opener = opener || document.activeElement;
    dlg.showModal();
    var first = $('[autofocus], input, button, a', dlg);
    if (first) first.focus();
    return true;
  }
  function wireDialog(dlg) {
    if (!dlg) return;
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { dlg.close(); return; }
      if (e.target.closest('[data-dialog-close]')) dlg.close();
    });
    dlg.addEventListener('close', function () { if (dlg._opener && dlg._opener.focus) dlg._opener.focus(); });
  }
  $$('dialog').forEach(wireDialog);
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-dialog]');
    if (!t) return;
    var dlg = $(t.getAttribute('data-open-dialog'));
    if (dlg && openDialog(dlg, t)) e.preventDefault();
  });

  /* Desktop nav disclosures: only one open, close on outside click and Escape */
  var header = $('.site-header');
  if (header) {
    header.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d.tagName === 'DETAILS' && d.open && d.classList.contains('nav-item')) {
        $$('.nav-desktop .nav-item[open]', header).forEach(function (o) { if (o !== d) o.open = false; });
      }
    }, true);
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) $$('.nav-desktop details[open]', header).forEach(function (d) { d.open = false; }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = $$('.nav-desktop details[open]', header);
      if (open.length) { var last = open[open.length - 1]; last.open = false; $('summary', last).focus(); }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  function setCartCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderCart(html) {
    if (!cartDrawer) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $('[data-cart-drawer-content]', tmp);
    var cur = $('[data-cart-drawer-content]', cartDrawer);
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var c = $('[data-cart-drawer-count]', tmp); if (c) { setCartCount(c.textContent.trim()); var dc = $('[data-cart-drawer-count]', cartDrawer); if (dc) dc.textContent = c.textContent.trim(); }
  }
  function refreshCart() {
    if (!cartDrawer || !window.fetch) return Promise.resolve();
    cartDrawer.setAttribute('aria-busy', 'true');
    return fetch(window.psRoutes.cart + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); }).then(renderCart)
      .then(function () { cartDrawer.removeAttribute('aria-busy'); }, function () { cartDrawer.removeAttribute('aria-busy'); });
  }
  function openCart(opener) {
    if (!cartDrawer || !supportsDialog) { location.href = window.psRoutes.cart; return; }
    refreshCart().then(function () { openDialog(cartDrawer, opener); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart]');
    if (!t || !cartDrawer || !supportsDialog) return;
    e.preventDefault(); openCart(t);
  });
  /* Quantity and remove inside the drawer */
  if (cartDrawer) {
    var pending = null;
    function change(line, qty) {
      if (!window.fetch) return;
      cartDrawer.setAttribute('aria-busy', 'true');
      var msg = $('[data-cart-message]', cartDrawer); if (msg) { msg.hidden = true; }
      fetch(window.psRoutes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { if (!r.ok) throw new Error('The cart could not be updated. Try again.'); return refreshCart(); })
        .catch(function (err) { cartDrawer.removeAttribute('aria-busy'); if (msg) { msg.textContent = err.message; msg.hidden = false; } });
    }
    cartDrawer.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-line]'); if (!input) return;
      clearTimeout(pending);
      pending = setTimeout(function () { change(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0)); }, 250);
    });
    cartDrawer.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove-line]'); if (!rm) return;
      e.preventDefault(); change(parseInt(rm.getAttribute('data-remove-line'), 10), 0);
    });
  }

  /* ---------- Quantity steppers (anywhere) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = $('input', b.closest('.qty-input'));
    var v = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
    v = Math.max(min, v + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form ---------- */
  var form = $('[data-product-form]');
  if (form) {
    var json = $('[data-product-json]');
    var product = json ? JSON.parse(json.textContent) : null;
    var idInput = $('[name=id]', form);
    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var addBtn = $('[data-add]', form);
    var addLabel = addBtn ? addBtn.getAttribute('data-label-add') : 'Add to cart';
    var status = $('[data-add-status]');
    var gallery = $('[data-gallery]');
    var stickyPrice = $('[data-sticky-price]');
    var money = function (cents) {
      var fmt = form.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };
    function selectedOptions() {
      return $$('[data-option-index]', form).map(function (group) {
        var checked = $('input:checked', group); if (checked) return checked.value;
        var sel = $('select', group); return sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
    }
    function markAvailability(opts) {
      $$('[data-option-index]', form).forEach(function (group, gi) {
        $$('input', group).forEach(function (input) {
          var test = opts.slice(); test[gi] = input.value;
          var v = findVariant(test);
          var label = $('label[for="' + input.id + '"]', group);
          if (!label) return;
          var exists = !!v, available = v && v.available;
          label.classList.toggle('is-unavailable', !exists || !available);
          label.title = !exists ? 'Not available in this combination' : (!available ? 'Sold out' : '');
        });
        var current = $('input:checked', group);
        var nameEl = $('[data-selected]', group);
        if (nameEl && current) nameEl.textContent = current.value;
      });
    }
    function showImage(mediaId) {
      if (!gallery) return;
      var main = $('[data-gallery-main]', gallery);
      var thumb = $('[data-media-id="' + mediaId + '"]', gallery);
      if (!main || !thumb) return;
      var img = $('img', thumb);
      main.src = thumb.getAttribute('data-src') || img.src;
      main.srcset = thumb.getAttribute('data-srcset') || '';
      main.setAttribute('data-full', thumb.getAttribute('data-full') || main.src);
      main.alt = img.alt;
      $$('[data-media-id]', gallery).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      var count = $('[data-gallery-index]', gallery); if (count) count.textContent = thumb.getAttribute('data-index') || '1';
      if (window.innerWidth < 900) main.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    function update() {
      if (!product) return;
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      var note = $('[data-option-note]', form);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Not available in this combination'; }
        if (note) { note.textContent = 'This combination is not offered. Choose another finish or size.'; note.hidden = false; }
        return;
      }
      if (note) note.hidden = true;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addLabel : 'Sold out'; }
      var sb = $('[data-sticky-add]'); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.featured_media) showImage(v.featured_media.id);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      var original = addBtn.textContent;
      addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); addBtn.textContent = 'Adding';
      if (status) { status.hidden = true; status.classList.remove('form-message--error'); }
      var fd = new FormData(form);
      fetch(window.psRoutes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'This item could not be added.');
          return fetch(window.psRoutes.cartJson, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          if (cartDrawer && supportsDialog) { openCart(addBtn); }
          else if (status) { status.innerHTML = 'Added to your cart. <a href="' + window.psRoutes.cart + '">View cart</a>'; status.hidden = false; }
        })
        .catch(function (err) {
          if (status) { status.textContent = err.message; status.classList.add('form-message--error'); status.hidden = false; }
        })
        .then(function () { addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); addBtn.textContent = original; });
    });
    /* Gallery: thumbnails and zoom */
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var t = e.target.closest('[data-media-id]'); if (t) { showImage(t.getAttribute('data-media-id')); return; }
        if (e.target.closest('[data-zoom]')) {
          var dlg = $('[data-lightbox]'); var main = $('[data-gallery-main]', gallery);
          if (dlg && main && supportsDialog) { $('img', dlg).src = main.getAttribute('data-full') || main.src; $('img', dlg).alt = main.alt; openDialog(dlg, e.target.closest('[data-zoom]')); }
        }
      });
    }
    /* Sticky purchase bar (phones): visible only after the real add button leaves the viewport */
    var sticky = $('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      }, { threshold: 0 });
      io.observe(addBtn);
      var sb2 = $('[data-sticky-add]', sticky);
      if (sb2) sb2.addEventListener('click', function () {
        if (addBtn.disabled) { $('.buy').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        addBtn.click();
      });
    }
    update();
  }

  /* ---------- Collection: sort auto-submit ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var f = sort.closest('form'); if (f) f.submit(); });

  /* ---------- Cart page: submit on quantity change ---------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var timer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="updates"]')) return;
      clearTimeout(timer); timer = setTimeout(function () { cartForm.submit(); }, 300);
    });
  }
})();
